import { Injectable } from '@angular/core';
import { map, shareReplay, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ClientPageSectionModel } from '../../domain/models/dynamic-form-schema.model';
import { SelectionService } from './selection.service';
import { ApplicationService } from '../../features/application/services/application.service';

@Injectable({
    providedIn: 'root'
})
export class DynamicFormOptionsService {
    constructor(
        private readonly selectionService: SelectionService,
        private readonly applicationService: ApplicationService
    ) {}

    enrichSectionsWithOptions(
        sections: ClientPageSectionModel[],
        applicationId?: number
    ): ClientPageSectionModel[] {
        sections.forEach((section) => {
            section.rows.forEach((row) => {
                row.fields.forEach((field) => {
                    const supportsOptions = [
                        'select',
                        'single-select',
                        'multi-select'
                    ].includes(field.type);
                    const supportsSiteSelect = field.type === 'site-select';
                    const optionsSource = field.optionsSource ?? field.key;

                    if (supportsSiteSelect) {
                        if (!applicationId) {
                            field.options$ = of([]);
                            field.optionsResolved = [];
                        } else {
                            field.options$ = this.applicationService
                                .getProviderSiteOptions(applicationId)
                                .pipe(
                                    map((result) => result.sites || []),
                                    tap((options) => {
                                        field.optionsResolved = options;
                                    }),
                                    shareReplay(1)
                                );
                        }

                        return;
                    }

                    if (!supportsOptions || !optionsSource) {
                        return;
                    }

                    field.options$ = this.selectionService
                        .getSelectionsByOptionsKey(optionsSource)
                        .pipe(
                            tap((options) => {
                                field.optionsResolved = options;
                            }),
                            shareReplay(1)
                        );
                });
            });
        });
        return sections;
    }
}
